// ============================================================
// PETFLYCHECK SEO DATA - EXTENDED (Part 2)
// Additional airlines, countries, breeds, and guides
// ============================================================

// ==================== ADDITIONAL AIRLINES ====================
export const additionalAirlinesData = {
  "singapore-airlines": {
    slug: "singapore-airlines",
    name: "Singapore Airlines",
    code: "SQ",
    country: "Singapore",
    alliance: "Star Alliance",
    officialPolicyUrl: "https://www.singaporeair.com/en_UK/us/travel-info/special-assistance/travelling-with-pets/",
    lastVerified: "2026",
    cabinAllowed: false,
    cabinNotes: "Singapore Airlines does NOT allow pets in cabin except registered service animals",
    cargoAllowed: true,
    cargoMaxWeight: 100,
    cargoMinAge: 12,
    cargoFee: "Based on volumetric weight",
    cargoProgram: "Singapore Airlines Cargo",
    restrictedBreeds: { dogs: [], cats: [], reason: "Singapore has strict breed import regulations" },
    brachycephalicPolicy: {
      restricted: true,
      breeds: ["All snub-nosed breeds"],
      notes: "Brachycephalic breeds face additional scrutiny and may be refused",
      source: "Singapore Airlines cargo policy"
    },
    documentsRequired: ["AVS Import Permit", "Veterinary health certificate", "Rabies vaccination", "Microchip documentation"],
    commonRejectionReasons: ["Missing AVS permit", "Crate non-compliant", "Documentation errors"],
    seoTitle: "Singapore Airlines Pet Policy 2026 | Cargo Rules & Requirements",
    seoDescription: "Singapore Airlines pet travel guide. Cargo-only transport, AVS permit requirements, crate specifications. No cabin pets allowed.",
    seoKeywords: ["Singapore Airlines pet policy", "SQ pet cargo", "Singapore Airlines dog travel"]
  },

  "cathay-pacific": {
    slug: "cathay-pacific",
    name: "Cathay Pacific",
    code: "CX",
    country: "Hong Kong",
    alliance: "Oneworld",
    officialPolicyUrl: "https://www.cathaypacific.com/cx/en_HK/travel-information/special-assistance/travelling-with-pets.html",
    lastVerified: "2026",
    cabinAllowed: true,
    cabinMaxWeight: 6,
    cabinCarrierDimensions: "56 x 36 x 23 cm",
    cabinFee: "HKD 2,560-3,840",
    cargoAllowed: true,
    cargoMaxWeight: 45,
    cargoMinAge: 10,
    cargoFee: "Based on route and weight",
    restrictedBreeds: { dogs: [], cats: [], reason: "Hong Kong import regulations apply" },
    brachycephalicPolicy: {
      restricted: true,
      breeds: ["Bulldog", "Pug", "Boston Terrier", "Boxer", "Shih Tzu"],
      notes: "Snub-nosed breeds restricted from cargo during hot months",
      source: "Cathay Pacific policy"
    },
    documentsRequired: ["Health certificate", "Rabies vaccination", "Import permit for destination"],
    commonRejectionReasons: ["Crate size issues", "Documentation incomplete"],
    seoTitle: "Cathay Pacific Pet Policy 2026 | Cabin & Cargo Guide",
    seoDescription: "Cathay Pacific pet travel rules. Cabin and cargo options, Hong Kong transit requirements, crate specifications.",
    seoKeywords: ["Cathay Pacific pet policy", "CX pet travel", "Hong Kong pet transport"]
  },

  "turkish-airlines": {
    slug: "turkish-airlines",
    name: "Turkish Airlines",
    code: "TK",
    country: "Turkey",
    alliance: "Star Alliance",
    officialPolicyUrl: "https://www.turkishairlines.com/en-int/any-questions/traveling-with-pets/",
    lastVerified: "2026",
    cabinAllowed: true,
    cabinMaxWeight: 8,
    cabinCarrierDimensions: "40 x 30 x 23 cm",
    cabinFee: "USD 70-120",
    cargoAllowed: true,
    cargoMaxWeight: 75,
    cargoMinAge: 10,
    cargoFee: "USD 100-400",
    restrictedBreeds: { dogs: ["Fighting breeds"], cats: [], reason: "Turkish regulations" },
    brachycephalicPolicy: {
      restricted: true,
      breeds: ["All brachycephalic breeds"],
      notes: "Cargo restrictions apply year-round",
      source: "Turkish Airlines policy"
    },
    documentsRequired: ["Veterinary health certificate", "Rabies vaccination", "Pet passport or equivalent"],
    commonRejectionReasons: ["Crate ventilation insufficient", "Missing documents", "Weight exceeded"],
    seoTitle: "Turkish Airlines Pet Policy 2026 | Cabin & Cargo Requirements",
    seoDescription: "Turkish Airlines pet travel guide. Istanbul hub rules, cabin fees, cargo requirements. One of the most pet-friendly airlines.",
    seoKeywords: ["Turkish Airlines pet policy", "Turkish Airlines dog travel", "Istanbul pet transit"]
  },

  "iberia": {
    slug: "iberia",
    name: "Iberia",
    code: "IB",
    country: "Spain",
    alliance: "Oneworld",
    officialPolicyUrl: "https://www.iberia.com/gb/luggage/pets/",
    lastVerified: "2026",
    cabinAllowed: true,
    cabinMaxWeight: 8,
    cabinCarrierDimensions: "45 x 35 x 25 cm",
    cabinFee: "EUR 50-150",
    cargoAllowed: true,
    cargoMaxWeight: 45,
    cargoMinAge: 10,
    cargoFee: "EUR 120-300",
    restrictedBreeds: { dogs: ["PPP breeds under Spanish law"], cats: [], reason: "Spanish Potentially Dangerous Dogs law" },
    brachycephalicPolicy: {
      restricted: true,
      breeds: ["Bulldog", "Pug", "Boxer"],
      notes: "Restricted in cargo hold",
      source: "Iberia policy"
    },
    documentsRequired: ["EU Pet Passport", "Rabies vaccination", "Health certificate"],
    commonRejectionReasons: ["Missing EU passport", "Crate issues"],
    seoTitle: "Iberia Pet Policy 2026 | Spain Flights & EU Pet Passport",
    seoDescription: "Iberia pet travel guide. EU Pet Passport requirements, Spanish breed laws, Madrid hub rules.",
    seoKeywords: ["Iberia pet policy", "Iberia dog travel", "Spain pet flight"]
  },

  "tap-portugal": {
    slug: "tap-portugal",
    name: "TAP Air Portugal",
    code: "TP",
    country: "Portugal",
    alliance: "Star Alliance",
    officialPolicyUrl: "https://www.flytap.com/en-pt/baggage/travelling-with-animals",
    lastVerified: "2026",
    cabinAllowed: true,
    cabinMaxWeight: 8,
    cabinCarrierDimensions: "55 x 40 x 20 cm",
    cabinFee: "EUR 55-100",
    cargoAllowed: true,
    cargoMaxWeight: 75,
    cargoMinAge: 10,
    cargoFee: "EUR 75-350",
    restrictedBreeds: { dogs: [], cats: [], reason: "Portugal follows EU regulations" },
    brachycephalicPolicy: {
      restricted: true,
      breeds: ["Snub-nosed breeds"],
      notes: "Cargo restrictions",
      source: "TAP policy"
    },
    documentsRequired: ["EU Pet Passport", "Rabies certificate", "Health certificate"],
    commonRejectionReasons: ["Documentation errors", "Crate compliance"],
    seoTitle: "TAP Portugal Pet Policy 2026 | Lisbon Hub & EU Travel",
    seoDescription: "TAP Air Portugal pet travel. EU passport requirements, Lisbon transit rules, cargo and cabin options.",
    seoKeywords: ["TAP Portugal pet policy", "TAP pet travel", "Portugal pet flight"]
  },

  "air-canada": {
    slug: "air-canada",
    name: "Air Canada",
    code: "AC",
    country: "Canada",
    alliance: "Star Alliance",
    officialPolicyUrl: "https://www.aircanada.com/ca/en/aco/home/plan/special-assistance/travelling-with-pets.html",
    lastVerified: "2026",
    cabinAllowed: true,
    cabinMaxWeight: 10,
    cabinCarrierDimensions: "43 x 28 x 22 cm",
    cabinFee: "CAD 50-118",
    cargoAllowed: true,
    cargoMaxWeight: 45,
    cargoMinAge: 8,
    cargoFee: "CAD 110-295",
    cargoProgram: "Air Canada Cargo",
    restrictedBreeds: { dogs: [], cats: [], reason: "Canada has no federal breed bans" },
    brachycephalicPolicy: {
      restricted: true,
      breeds: ["All snub-nosed dogs and cats"],
      notes: "Air Canada Cargo does not accept brachycephalic breeds May-October",
      source: "Air Canada Cargo policy"
    },
    temperatureRestrictions: { min: 45, max: 85, notes: "Seasonal embargoes apply" },
    documentsRequired: ["Health certificate", "Rabies vaccination", "Import documents for international"],
    commonRejectionReasons: ["Temperature embargo", "Snub-nose breed", "Crate issues"],
    seoTitle: "Air Canada Pet Policy 2026 | Cargo & Cabin Travel Guide",
    seoDescription: "Air Canada pet travel rules. Cabin fees, cargo program, seasonal restrictions, Canadian import rules.",
    seoKeywords: ["Air Canada pet policy", "Air Canada dog travel", "Canada pet flight"]
  },

  "alaska-airlines": {
    slug: "alaska-airlines",
    name: "Alaska Airlines",
    code: "AS",
    country: "United States",
    alliance: "Oneworld",
    officialPolicyUrl: "https://www.alaskaair.com/content/travel-info/policies/pets-background",
    lastVerified: "2026",
    cabinAllowed: true,
    cabinMaxWeight: "No weight limit - must fit under seat",
    cabinCarrierDimensions: "17 x 11 x 7.5 inches",
    cabinFee: "USD 100",
    cargoAllowed: true,
    cargoMaxWeight: 150,
    cargoMinAge: 8,
    cargoFee: "USD 100-150",
    restrictedBreeds: { dogs: [], cats: [], reason: "No specific breed bans" },
    brachycephalicPolicy: {
      restricted: true,
      breeds: ["Snub-nosed breeds"],
      notes: "Additional restrictions apply",
      source: "Alaska Airlines policy"
    },
    temperatureRestrictions: { min: 45, max: 85, notes: "Standard temperature limits" },
    documentsRequired: ["Health certificate", "Rabies certificate"],
    commonRejectionReasons: ["Carrier size", "Temperature restrictions"],
    seoTitle: "Alaska Airlines Pet Policy 2026 | West Coast Pet Travel",
    seoDescription: "Alaska Airlines pet travel guide. Cabin and cargo options, Hawaii travel rules, temperature restrictions.",
    seoKeywords: ["Alaska Airlines pet policy", "Alaska Airlines dog travel", "Hawaii pet flight"]
  },

  "jetblue": {
    slug: "jetblue",
    name: "JetBlue",
    code: "B6",
    country: "United States",
    alliance: "None",
    officialPolicyUrl: "https://www.jetblue.com/traveling-together/traveling-with-pets",
    lastVerified: "2026",
    cabinAllowed: true,
    cabinMaxWeight: 20,
    cabinCarrierDimensions: "17 x 12.5 x 8.5 inches",
    cabinFee: "USD 125",
    cargoAllowed: false,
    cargoNotes: "JetBlue does NOT offer cargo pet transport",
    restrictedBreeds: { dogs: [], cats: [], reason: "No breed restrictions for cabin" },
    brachycephalicPolicy: {
      restricted: false,
      breeds: [],
      notes: "Cabin only - no cargo restrictions apply",
      source: "JetBlue policy"
    },
    documentsRequired: ["Health certificate recommended"],
    commonRejectionReasons: ["Carrier too large", "Pet behavior issues"],
    seoTitle: "JetBlue Pet Policy 2026 | Cabin-Only Travel Guide",
    seoDescription: "JetBlue pet travel guide. Cabin-only airline, carrier requirements, fees. No cargo option available.",
    seoKeywords: ["JetBlue pet policy", "JetBlue dog travel", "JetBlue pet fees"]
  },

  "southwest": {
    slug: "southwest",
    name: "Southwest Airlines",
    code: "WN",
    country: "United States",
    alliance: "None",
    officialPolicyUrl: "https://www.southwest.com/html/customer-service/traveling-with-animals.html",
    lastVerified: "2026",
    cabinAllowed: true,
    cabinMaxWeight: "Must fit under seat",
    cabinCarrierDimensions: "18.5 x 8.5 x 13.5 inches",
    cabinFee: "USD 95",
    cargoAllowed: false,
    cargoNotes: "Southwest does NOT transport pets in cargo",
    restrictedBreeds: { dogs: [], cats: [], reason: "No breed restrictions" },
    brachycephalicPolicy: {
      restricted: false,
      breeds: [],
      notes: "Cabin only - safe for snub-nosed breeds",
      source: "Southwest policy"
    },
    documentsRequired: ["Health certificate recommended for travel"],
    commonRejectionReasons: ["Carrier size", "Vaccination documentation"],
    seoTitle: "Southwest Airlines Pet Policy 2026 | Cabin Travel Guide",
    seoDescription: "Southwest Airlines pet travel. Cabin-only, low fees, no cargo option. Perfect for small pets and snub-nosed breeds.",
    seoKeywords: ["Southwest pet policy", "Southwest dog travel", "Southwest pet fees"]
  },

  "norwegian": {
    slug: "norwegian",
    name: "Norwegian Air",
    code: "DY",
    country: "Norway",
    alliance: "None",
    officialPolicyUrl: "https://www.norwegian.com/en/travel-info/baggage/pets/",
    lastVerified: "2026",
    cabinAllowed: true,
    cabinMaxWeight: 8,
    cabinCarrierDimensions: "45 x 35 x 20 cm",
    cabinFee: "EUR 50-75",
    cargoAllowed: false,
    cargoNotes: "Norwegian does not transport pets in cargo hold",
    restrictedBreeds: { dogs: [], cats: [], reason: "No breed restrictions" },
    brachycephalicPolicy: {
      restricted: false,
      breeds: [],
      notes: "Safe for snub-nosed - cabin only",
      source: "Norwegian policy"
    },
    documentsRequired: ["EU Pet Passport", "Health certificate"],
    commonRejectionReasons: ["Missing EU passport", "Carrier size"],
    seoTitle: "Norwegian Air Pet Policy 2026 | Budget Airline Pet Travel",
    seoDescription: "Norwegian Air pet travel guide. Cabin-only, budget-friendly option for European pet travel.",
    seoKeywords: ["Norwegian Air pet policy", "Norwegian pet travel", "budget airline pets"]
  },

  "ryanair": {
    slug: "ryanair",
    name: "Ryanair",
    code: "FR",
    country: "Ireland",
    alliance: "None",
    officialPolicyUrl: "https://www.ryanair.com/",
    lastVerified: "2026",
    cabinAllowed: false,
    cabinNotes: "Ryanair does NOT allow any pets on board except registered guide/assistance dogs",
    cargoAllowed: false,
    cargoNotes: "No pet transport available",
    restrictedBreeds: { dogs: ["All breeds - no pets allowed"], cats: ["All - no pets allowed"], reason: "No pet transport" },
    brachycephalicPolicy: {
      restricted: true,
      breeds: ["All"],
      notes: "No pets allowed on Ryanair flights",
      source: "Ryanair policy"
    },
    documentsRequired: [],
    commonRejectionReasons: ["Ryanair does not transport pets"],
    seoTitle: "Ryanair Pet Policy 2026 | NO PETS ALLOWED",
    seoDescription: "Important: Ryanair does NOT allow pets. No cabin, no cargo. Find alternative airlines for pet travel.",
    seoKeywords: ["Ryanair pet policy", "Ryanair pets", "Ryanair no pets"]
  },

  "easyjet": {
    slug: "easyjet",
    name: "EasyJet",
    code: "U2",
    country: "United Kingdom",
    alliance: "None",
    officialPolicyUrl: "https://www.easyjet.com/",
    lastVerified: "2026",
    cabinAllowed: false,
    cabinNotes: "EasyJet does NOT allow pets except registered assistance dogs",
    cargoAllowed: false,
    cargoNotes: "No cargo pet transport",
    restrictedBreeds: { dogs: ["All"], cats: ["All"], reason: "No pet transport" },
    brachycephalicPolicy: { restricted: true, breeds: ["All"], notes: "No pets", source: "EasyJet" },
    documentsRequired: [],
    commonRejectionReasons: ["EasyJet does not transport pets"],
    seoTitle: "EasyJet Pet Policy 2026 | NO PETS ALLOWED",
    seoDescription: "Warning: EasyJet does NOT allow pets on flights. No cabin, no cargo options. Choose another airline.",
    seoKeywords: ["EasyJet pet policy", "EasyJet pets", "EasyJet no pets"]
  },

  "finnair": {
    slug: "finnair",
    name: "Finnair",
    code: "AY",
    country: "Finland",
    alliance: "Oneworld",
    officialPolicyUrl: "https://www.finnair.com/en/information-services/baggage/travelling-with-pets",
    lastVerified: "2026",
    cabinAllowed: true,
    cabinMaxWeight: 8,
    cabinCarrierDimensions: "55 x 40 x 23 cm",
    cabinFee: "EUR 40-70",
    cargoAllowed: true,
    cargoMaxWeight: 75,
    cargoMinAge: 10,
    cargoFee: "EUR 80-200",
    restrictedBreeds: { dogs: [], cats: [], reason: "Finland has no breed restrictions" },
    brachycephalicPolicy: {
      restricted: true,
      breeds: ["Snub-nosed breeds"],
      notes: "Cargo restrictions apply",
      source: "Finnair policy"
    },
    documentsRequired: ["EU Pet Passport", "Rabies vaccination", "No tapeworm treatment needed FROM Finland"],
    commonRejectionReasons: ["Crate issues", "Documentation"],
    seoTitle: "Finnair Pet Policy 2026 | Helsinki Hub Pet Travel",
    seoDescription: "Finnair pet travel guide. Helsinki transit rules, EU passport requirements, affordable cabin fees.",
    seoKeywords: ["Finnair pet policy", "Finnair dog travel", "Helsinki pet transit"]
  },

  "sas": {
    slug: "sas",
    name: "SAS Scandinavian Airlines",
    code: "SK",
    country: "Sweden",
    alliance: "Star Alliance",
    officialPolicyUrl: "https://www.flysas.com/en/travel-info/baggage/animals/",
    lastVerified: "2026",
    cabinAllowed: true,
    cabinMaxWeight: 8,
    cabinCarrierDimensions: "40 x 25 x 23 cm",
    cabinFee: "EUR 60-90",
    cargoAllowed: true,
    cargoMaxWeight: 75,
    cargoMinAge: 10,
    cargoFee: "EUR 100-250",
    restrictedBreeds: { dogs: [], cats: [], reason: "Scandinavian countries have no breed bans" },
    brachycephalicPolicy: {
      restricted: true,
      breeds: ["Brachycephalic breeds"],
      notes: "Cargo restrictions",
      source: "SAS policy"
    },
    documentsRequired: ["EU Pet Passport", "Rabies certificate", "Health certificate"],
    commonRejectionReasons: ["Documentation", "Crate compliance"],
    seoTitle: "SAS Scandinavian Airlines Pet Policy 2026 | Nordic Travel",
    seoDescription: "SAS pet travel guide. Scandinavian routes, EU passport, cabin and cargo options.",
    seoKeywords: ["SAS pet policy", "Scandinavian Airlines pets", "Nordic pet travel"]
  },

  "icelandair": {
    slug: "icelandair",
    name: "Icelandair",
    code: "FI",
    country: "Iceland",
    alliance: "None",
    officialPolicyUrl: "https://www.icelandair.com/support/baggage/traveling-with-pets/",
    lastVerified: "2026",
    cabinAllowed: false,
    cabinNotes: "Icelandair does NOT allow pets in cabin",
    cargoAllowed: true,
    cargoMaxWeight: 50,
    cargoMinAge: 10,
    cargoFee: "USD 200-400",
    cargoProgram: "Icelandair Cargo",
    restrictedBreeds: { dogs: [], cats: [], reason: "Iceland has strict import rules" },
    brachycephalicPolicy: {
      restricted: true,
      breeds: ["All snub-nosed"],
      notes: "Not recommended for cargo",
      source: "Icelandair policy"
    },
    specialNotes: "Iceland requires import permit and specific health requirements. Pets cannot transit in Iceland for other destinations.",
    documentsRequired: ["Import permit from MAST", "Health certificate", "Rabies certificate", "Parasite treatment"],
    commonRejectionReasons: ["Missing Iceland import permit", "Incorrect health documentation"],
    seoTitle: "Icelandair Pet Policy 2026 | Iceland Import Rules",
    seoDescription: "Icelandair pet travel. Strict Iceland import requirements, cargo-only transport, mandatory permits.",
    seoKeywords: ["Icelandair pet policy", "Iceland pet import", "flying pets to Iceland"]
  },

  "aer-lingus": {
    slug: "aer-lingus",
    name: "Aer Lingus",
    code: "EI",
    country: "Ireland",
    alliance: "None",
    officialPolicyUrl: "https://www.aerlingus.com/travel-information/baggage-information/travelling-with-pets/",
    lastVerified: "2026",
    cabinAllowed: true,
    cabinMaxWeight: 10,
    cabinCarrierDimensions: "48 x 33 x 20 cm",
    cabinFee: "EUR 35-55",
    cargoAllowed: true,
    cargoMaxWeight: 70,
    cargoMinAge: 10,
    cargoFee: "EUR 80-200",
    restrictedBreeds: { dogs: [], cats: [], reason: "Ireland follows EU regulations" },
    brachycephalicPolicy: {
      restricted: true,
      breeds: ["Snub-nosed breeds"],
      notes: "Cargo restrictions",
      source: "Aer Lingus policy"
    },
    documentsRequired: ["EU Pet Passport or AHC", "Rabies vaccination", "Tapeworm treatment for Ireland entry"],
    commonRejectionReasons: ["Missing tapeworm treatment", "Documentation errors"],
    seoTitle: "Aer Lingus Pet Policy 2026 | Ireland Pet Travel",
    seoDescription: "Aer Lingus pet travel guide. Ireland entry requirements, tapeworm treatment, EU passport rules.",
    seoKeywords: ["Aer Lingus pet policy", "Ireland pet travel", "Dublin pet flight"]
  }
};

// ==================== ADDITIONAL COUNTRIES ====================
export const additionalCountriesData = {
  "spain": {
    slug: "spain",
    name: "Spain",
    code: "ES",
    flag: "🇪🇸",
    importRules: {
      quarantine: false,
      quarantineDays: 0,
      microchipRequired: true,
      rabiesRequired: true,
      rabiesWaitingPeriod: "21 days",
      healthCertificate: true,
      importPermit: false,
      euPetPassport: "Required for EU, AHC for others"
    },
    specialRequirements: ["EU Pet Passport for EU residents", "PPP breed registration for dangerous dogs", "Liability insurance for certain breeds"],
    bannedBreeds: ["Pit Bull Terrier", "Staffordshire Bull Terrier", "American Staffordshire Terrier", "Rottweiler", "Dogo Argentino", "Fila Brasileiro", "Tosa Inu", "Akita Inu"],
    seoTitle: "Spain Pet Import Rules 2026 | EU Passport & PPP Breeds",
    seoDescription: "Bringing pets to Spain. EU Pet Passport, PPP dangerous dog breeds, regional regulations. Complete import guide.",
    seoKeywords: ["Spain pet import", "bring dog to Spain", "Spain PPP breeds", "EU pet passport Spain"]
  },

  "italy": {
    slug: "italy",
    name: "Italy",
    code: "IT",
    flag: "🇮🇹",
    importRules: {
      quarantine: false,
      quarantineDays: 0,
      microchipRequired: true,
      rabiesRequired: true,
      rabiesWaitingPeriod: "21 days",
      healthCertificate: true,
      importPermit: false,
      euPetPassport: "Required"
    },
    specialRequirements: ["EU Pet Passport", "Microchip before rabies", "No breed-specific legislation at national level"],
    seoTitle: "Italy Pet Import Rules 2026 | EU Requirements Guide",
    seoDescription: "Importing pets to Italy. EU Pet Passport requirements, rabies vaccination, Italian regulations.",
    seoKeywords: ["Italy pet import", "bring dog to Italy", "Italy pet rules"]
  },

  "netherlands": {
    slug: "netherlands",
    name: "Netherlands",
    code: "NL",
    flag: "🇳🇱",
    importRules: {
      quarantine: false,
      quarantineDays: 0,
      microchipRequired: true,
      rabiesRequired: true,
      rabiesWaitingPeriod: "21 days",
      healthCertificate: true,
      importPermit: false,
      euPetPassport: "Required"
    },
    specialRequirements: ["EU Pet Passport", "Pit Bull ban in place", "Must declare pets at customs"],
    bannedBreeds: ["Pit Bull Terrier"],
    seoTitle: "Netherlands Pet Import Rules 2026 | Dutch Regulations",
    seoDescription: "Bringing pets to Netherlands. Pit Bull ban, EU passport, Amsterdam entry requirements.",
    seoKeywords: ["Netherlands pet import", "bring dog to Netherlands", "Dutch pet rules"]
  },

  "switzerland": {
    slug: "switzerland",
    name: "Switzerland",
    code: "CH",
    flag: "🇨🇭",
    importRules: {
      quarantine: false,
      quarantineDays: 0,
      microchipRequired: true,
      rabiesRequired: true,
      rabiesWaitingPeriod: "21 days",
      healthCertificate: true,
      importPermit: false,
      euPetPassport: "Accepted but not required"
    },
    specialRequirements: ["Rabies vaccination mandatory", "Some cantons have breed restrictions", "Dog tax registration required"],
    bannedBreeds: ["Varies by canton - some ban Pit Bulls, Rottweilers"],
    seoTitle: "Switzerland Pet Import Rules 2026 | Canton Regulations",
    seoDescription: "Importing pets to Switzerland. Canton-specific breed rules, rabies requirements, customs declaration.",
    seoKeywords: ["Switzerland pet import", "bring dog to Switzerland", "Swiss pet rules"]
  },

  "new-zealand": {
    slug: "new-zealand",
    name: "New Zealand",
    code: "NZ",
    flag: "🇳🇿",
    importRules: {
      quarantine: true,
      quarantineDays: "Minimum 10 days",
      microchipRequired: true,
      rabiesRequired: true,
      rabiesWaitingPeriod: "180 days",
      healthCertificate: true,
      importPermit: true,
      bloodTest: "RNATT required"
    },
    specialRequirements: ["Only from approved countries", "6+ month preparation", "MPI import permit", "Quarantine facility booking"],
    seoTitle: "New Zealand Pet Import 2026 | Quarantine & Permit Guide",
    seoDescription: "Importing pets to New Zealand. Mandatory quarantine, RNATT blood test, approved countries only.",
    seoKeywords: ["New Zealand pet import", "NZ pet quarantine", "bring dog to New Zealand"]
  },

  "south-korea": {
    slug: "south-korea",
    name: "South Korea",
    code: "KR",
    flag: "🇰🇷",
    importRules: {
      quarantine: false,
      quarantineDays: 0,
      microchipRequired: true,
      rabiesRequired: true,
      rabiesWaitingPeriod: "30 days",
      healthCertificate: true,
      importPermit: false,
      bloodTest: "May be required"
    },
    specialRequirements: ["Health certificate within 10 days", "Rabies neutralizing antibody test from some countries"],
    seoTitle: "South Korea Pet Import Rules 2026 | Seoul Entry Guide",
    seoDescription: "Bringing pets to South Korea. Health certificate requirements, rabies rules, Seoul airport procedures.",
    seoKeywords: ["South Korea pet import", "bring dog to Korea", "Seoul pet travel"]
  },

  "thailand": {
    slug: "thailand",
    name: "Thailand",
    code: "TH",
    flag: "🇹🇭",
    importRules: {
      quarantine: false,
      quarantineDays: 0,
      microchipRequired: true,
      rabiesRequired: true,
      rabiesWaitingPeriod: "21 days",
      healthCertificate: true,
      importPermit: true,
      permitLeadTime: "15 days"
    },
    specialRequirements: ["Import permit from DLD Thailand", "Must arrive at approved airports", "Certificate from Thai embassy may be needed"],
    seoTitle: "Thailand Pet Import Rules 2026 | Bangkok Entry Requirements",
    seoDescription: "Importing pets to Thailand. Import permit, Bangkok airport rules, vaccination requirements.",
    seoKeywords: ["Thailand pet import", "bring dog to Thailand", "Bangkok pet travel"]
  },

  "mexico": {
    slug: "mexico",
    name: "Mexico",
    code: "MX",
    flag: "🇲🇽",
    importRules: {
      quarantine: false,
      quarantineDays: 0,
      microchipRequired: false,
      rabiesRequired: true,
      rabiesWaitingPeriod: "None",
      healthCertificate: true,
      healthCertificateValidity: "10 days",
      importPermit: false
    },
    specialRequirements: ["Health certificate endorsed by USDA (from US)", "Rabies vaccination current", "Pet must be healthy at entry"],
    seoTitle: "Mexico Pet Import Rules 2026 | Easy Entry Requirements",
    seoDescription: "Bringing pets to Mexico. One of the easiest countries for pet import. Health certificate and rabies only.",
    seoKeywords: ["Mexico pet import", "bring dog to Mexico", "Mexico pet travel"]
  },

  "brazil": {
    slug: "brazil",
    name: "Brazil",
    code: "BR",
    flag: "🇧🇷",
    importRules: {
      quarantine: false,
      quarantineDays: 0,
      microchipRequired: true,
      rabiesRequired: true,
      rabiesWaitingPeriod: "30 days",
      healthCertificate: true,
      importPermit: false
    },
    specialRequirements: ["International Veterinary Certificate (CVI)", "Must be endorsed by government authority", "Some vaccines required for dogs from certain countries"],
    seoTitle: "Brazil Pet Import Rules 2026 | South America Travel",
    seoDescription: "Importing pets to Brazil. International Veterinary Certificate, rabies requirements, São Paulo entry.",
    seoKeywords: ["Brazil pet import", "bring dog to Brazil", "Brazil pet travel"]
  },

  "hong-kong": {
    slug: "hong-kong",
    name: "Hong Kong",
    code: "HK",
    flag: "🇭🇰",
    importRules: {
      quarantine: "Possible",
      quarantineDays: "4 months from non-approved countries",
      microchipRequired: true,
      rabiesRequired: true,
      rabiesWaitingPeriod: "Varies by country",
      healthCertificate: true,
      importPermit: true,
      bloodTest: "May be required"
    },
    specialRequirements: ["Special Permit required", "Country category determines requirements", "Approved countries have easier process"],
    seoTitle: "Hong Kong Pet Import Rules 2026 | Permit & Quarantine",
    seoDescription: "Importing pets to Hong Kong. Special permit requirements, country categories, potential quarantine.",
    seoKeywords: ["Hong Kong pet import", "bring dog to Hong Kong", "HK pet quarantine"]
  }
};

// ==================== ADDITIONAL BREEDS ====================
export const additionalBreedsData = {
  "boston-terrier": {
    slug: "boston-terrier",
    name: "Boston Terrier",
    type: "dog",
    category: "brachycephalic",
    riskLevel: "HIGH",
    physicalTraits: { weight: "12-25 lbs (5-11 kg)", height: "15-17 inches", lifespan: "11-13 years" },
    travelRisks: {
      respiratory: "High - shortened airways",
      heatStroke: "High",
      stress: "Moderate",
      altitude: "Moderate"
    },
    airlineRestrictions: {
      bannedFromCargo: ["Most major airlines"],
      cabinAllowed: ["Yes - usually under weight limit"],
      notes: "Boston Terriers can typically fly cabin due to size. Cargo banned on most airlines."
    },
    recommendedCrateSize: { length: "24-28 inches", width: "18-20 inches", height: "19-21 inches" },
    travelTips: ["Cabin only", "Avoid hot weather", "Bring cooling accessories", "Early morning flights"],
    seoTitle: "Boston Terrier Air Travel 2026 | Airline Restrictions Guide",
    seoDescription: "Flying with a Boston Terrier. Cargo bans, cabin travel tips, airline policies. Keep your Boston safe.",
    seoKeywords: ["Boston Terrier flying", "Boston Terrier airline", "Boston Terrier travel"]
  },

  "boxer": {
    slug: "boxer",
    name: "Boxer",
    type: "dog",
    category: "brachycephalic",
    riskLevel: "HIGH",
    physicalTraits: { weight: "50-80 lbs (23-36 kg)", height: "21-25 inches", lifespan: "10-12 years" },
    travelRisks: {
      respiratory: "High - brachycephalic",
      heatStroke: "High",
      stress: "Moderate-High",
      altitude: "Moderate"
    },
    airlineRestrictions: {
      bannedFromCargo: ["Most major airlines"],
      cabinAllowed: ["No - too large"],
      notes: "Boxers are too large for cabin and banned from cargo. Consider ground transport."
    },
    alternativeTransport: ["Ground transport services", "Pet relocation specialists", "Driving"],
    seoTitle: "Boxer Dog Air Travel 2026 | BANNED from Most Airlines",
    seoDescription: "Boxers face severe flight restrictions. Too large for cabin, banned from cargo. Alternative transport options.",
    seoKeywords: ["Boxer dog flying", "Boxer airline ban", "Boxer travel"]
  },

  "shih-tzu": {
    slug: "shih-tzu",
    name: "Shih Tzu",
    type: "dog",
    category: "brachycephalic",
    riskLevel: "MODERATE-HIGH",
    physicalTraits: { weight: "9-16 lbs (4-7 kg)", height: "9-10.5 inches", lifespan: "10-18 years" },
    travelRisks: {
      respiratory: "Moderate-High",
      heatStroke: "Moderate-High (long coat)",
      stress: "Moderate",
      altitude: "Moderate"
    },
    airlineRestrictions: {
      bannedFromCargo: ["Many airlines"],
      cabinAllowed: ["Yes - small size"],
      notes: "Shih Tzus can fly cabin. Cargo restrictions vary by airline."
    },
    recommendedCrateSize: { length: "22-24 inches", width: "14-16 inches", height: "14-16 inches" },
    travelTips: ["Cabin preferred", "Groom before travel", "Watch for overheating", "Keep coat trimmed for travel"],
    seoTitle: "Shih Tzu Air Travel 2026 | Safe Flying Guide",
    seoDescription: "Flying with a Shih Tzu safely. Cabin travel tips, grooming advice, airline policies.",
    seoKeywords: ["Shih Tzu flying", "Shih Tzu airline", "Shih Tzu travel"]
  },

  "cavalier-king-charles": {
    slug: "cavalier-king-charles",
    name: "Cavalier King Charles Spaniel",
    type: "dog",
    category: "brachycephalic",
    riskLevel: "MODERATE-HIGH",
    physicalTraits: { weight: "12-18 lbs (5-8 kg)", height: "12-13 inches", lifespan: "12-15 years" },
    travelRisks: {
      respiratory: "Moderate (less severe than bulldog types)",
      heatStroke: "Moderate",
      stress: "Low-Moderate",
      altitude: "Moderate"
    },
    airlineRestrictions: {
      bannedFromCargo: ["Some airlines"],
      cabinAllowed: ["Yes"],
      notes: "Cavaliers are borderline brachycephalic. Some airlines allow cargo, check specific policy."
    },
    seoTitle: "Cavalier King Charles Spaniel Air Travel 2026",
    seoDescription: "Flying with a Cavalier King Charles Spaniel. Airline policies, health considerations, travel tips.",
    seoKeywords: ["Cavalier King Charles flying", "Cavalier spaniel airline", "Cavalier travel"]
  },

  "chihuahua": {
    slug: "chihuahua",
    name: "Chihuahua",
    type: "dog",
    category: "toy",
    riskLevel: "LOW",
    physicalTraits: { weight: "2-6 lbs (1-3 kg)", height: "5-8 inches", lifespan: "14-16 years" },
    travelRisks: {
      respiratory: "Low",
      heatStroke: "Low (but sensitive to cold)",
      stress: "Moderate (can be nervous)",
      altitude: "Low"
    },
    airlineRestrictions: {
      bannedFromCargo: [],
      cabinAllowed: ["Yes - ideal cabin travelers"],
      notes: "Chihuahuas are perfect cabin pets due to tiny size."
    },
    recommendedCrateSize: { length: "18-22 inches", width: "12-14 inches", height: "12-14 inches" },
    travelTips: ["Cabin ideal", "Bring blanket (sensitive to cold)", "Familiar toy for comfort", "Choose quiet carrier"],
    seoTitle: "Chihuahua Air Travel 2026 | Perfect Cabin Pet Guide",
    seoDescription: "Flying with a Chihuahua. Ideal cabin traveler, carrier recommendations, comfort tips.",
    seoKeywords: ["Chihuahua flying", "Chihuahua airline", "Chihuahua travel"]
  },

  "yorkshire-terrier": {
    slug: "yorkshire-terrier",
    name: "Yorkshire Terrier",
    type: "dog",
    category: "toy",
    riskLevel: "LOW",
    physicalTraits: { weight: "4-7 lbs (2-3 kg)", height: "7-8 inches", lifespan: "11-15 years" },
    travelRisks: {
      respiratory: "Low",
      heatStroke: "Low",
      stress: "Moderate",
      altitude: "Low"
    },
    airlineRestrictions: {
      bannedFromCargo: [],
      cabinAllowed: ["Yes - excellent cabin travelers"],
      notes: "Yorkies are ideal for cabin travel due to small size."
    },
    recommendedCrateSize: { length: "18-22 inches", width: "12-14 inches", height: "12-14 inches" },
    travelTips: ["Cabin travel ideal", "Groom before flight", "Bring treats", "Quiet carrier recommended"],
    seoTitle: "Yorkshire Terrier Air Travel 2026 | Cabin Travel Guide",
    seoDescription: "Flying with a Yorkshire Terrier. Perfect cabin companion, travel tips, carrier guide.",
    seoKeywords: ["Yorkshire Terrier flying", "Yorkie airline", "Yorkie travel"]
  },

  "beagle": {
    slug: "beagle",
    name: "Beagle",
    type: "dog",
    category: "standard",
    riskLevel: "LOW",
    physicalTraits: { weight: "20-30 lbs (9-14 kg)", height: "13-15 inches", lifespan: "10-15 years" },
    travelRisks: {
      respiratory: "Low",
      heatStroke: "Low",
      stress: "Low-Moderate",
      altitude: "Low"
    },
    airlineRestrictions: {
      bannedFromCargo: [],
      cabinAllowed: ["No - usually too large"],
      notes: "Beagles typically travel cargo. Good temperament for travel."
    },
    recommendedCrateSize: { length: "30-36 inches", width: "20-22 inches", height: "24-26 inches", IATASize: "300-400 series" },
    travelTips: ["Cargo typically required", "Good travelers with calm temperament", "Exercise before flight", "Familiar bedding"],
    seoTitle: "Beagle Air Travel 2026 | Cargo & Crate Guide",
    seoDescription: "Flying with a Beagle. Cargo travel guide, crate sizing, preparation tips. Beagles are good travelers.",
    seoKeywords: ["Beagle flying", "Beagle airline", "Beagle crate size"]
  },

  "border-collie": {
    slug: "border-collie",
    name: "Border Collie",
    type: "dog",
    category: "standard",
    riskLevel: "LOW",
    physicalTraits: { weight: "30-55 lbs (14-25 kg)", height: "18-22 inches", lifespan: "12-15 years" },
    travelRisks: {
      respiratory: "Low",
      heatStroke: "Moderate (thick coat)",
      stress: "Moderate (high energy)",
      altitude: "Low"
    },
    airlineRestrictions: {
      bannedFromCargo: [],
      cabinAllowed: ["No - too large"],
      notes: "Border Collies travel cargo. May need extra exercise before travel."
    },
    recommendedCrateSize: { length: "36-42 inches", width: "24-28 inches", height: "28-32 inches", IATASize: "400-500 series" },
    travelTips: ["Long exercise before flight", "Mental stimulation beforehand", "Familiar items in crate", "Water available"],
    seoTitle: "Border Collie Air Travel 2026 | High-Energy Breed Guide",
    seoDescription: "Flying with a Border Collie. Managing high energy for travel, crate requirements, preparation tips.",
    seoKeywords: ["Border Collie flying", "Border Collie airline", "Border Collie travel"]
  },

  "dachshund": {
    slug: "dachshund",
    name: "Dachshund",
    type: "dog",
    category: "small",
    riskLevel: "LOW-MODERATE",
    physicalTraits: { weight: "11-32 lbs (5-15 kg)", height: "8-9 inches (standard)", lifespan: "12-16 years" },
    travelRisks: {
      respiratory: "Low",
      heatStroke: "Low",
      stress: "Moderate",
      altitude: "Low"
    },
    airlineRestrictions: {
      bannedFromCargo: [],
      cabinAllowed: ["Miniature - yes", "Standard - depends on weight"],
      notes: "Miniature Dachshunds fit cabin easily. Standards may need cargo."
    },
    recommendedCrateSize: { length: "24-30 inches", width: "16-18 inches", height: "16-20 inches" },
    travelTips: ["Watch back stress", "Supportive bedding important", "Avoid jumping", "Cabin if possible"],
    seoTitle: "Dachshund Air Travel 2026 | Back Care & Travel Tips",
    seoDescription: "Flying with a Dachshund. Special back considerations, cabin vs cargo, travel preparation.",
    seoKeywords: ["Dachshund flying", "Dachshund airline", "Dachshund travel"]
  },

  "poodle": {
    slug: "poodle",
    name: "Poodle",
    type: "dog",
    category: "varies",
    riskLevel: "LOW",
    physicalTraits: { weight: "Toy: 4-6 lbs, Mini: 10-15 lbs, Standard: 40-70 lbs", lifespan: "10-18 years" },
    travelRisks: {
      respiratory: "Low",
      heatStroke: "Low (minimal shedding coat)",
      stress: "Low-Moderate",
      altitude: "Low"
    },
    airlineRestrictions: {
      bannedFromCargo: [],
      cabinAllowed: ["Toy and Miniature - yes", "Standard - no"],
      notes: "Size determines travel method. Poodles are excellent travelers."
    },
    recommendedCrateSize: { 
      notes: "Toy: 18-24 inches, Miniature: 24-30 inches, Standard: 36-48 inches" 
    },
    travelTips: ["Groom before travel", "Intelligent - adapts well", "Size appropriate carrier", "Good temperament for travel"],
    seoTitle: "Poodle Air Travel 2026 | All Sizes Guide",
    seoDescription: "Flying with a Poodle. Toy, Miniature, and Standard Poodle travel guide. Excellent travelers.",
    seoKeywords: ["Poodle flying", "Poodle airline", "Poodle travel", "toy poodle flying"]
  },

  "husky": {
    slug: "husky",
    name: "Siberian Husky",
    type: "dog",
    category: "large",
    riskLevel: "LOW-MODERATE",
    physicalTraits: { weight: "35-60 lbs (16-27 kg)", height: "20-23.5 inches", lifespan: "12-14 years" },
    travelRisks: {
      respiratory: "Low",
      heatStroke: "Moderate-High (thick coat, heat sensitive)",
      stress: "Moderate (high energy)",
      altitude: "Low"
    },
    airlineRestrictions: {
      bannedFromCargo: [],
      cabinAllowed: ["No - too large"],
      notes: "Huskies travel cargo. Heat sensitivity important consideration."
    },
    temperatureRecommendations: "Avoid summer travel. Best in cooler months. Temperature embargoes may apply.",
    recommendedCrateSize: { length: "42-48 inches", width: "28-32 inches", height: "30-35 inches", IATASize: "500-700 series" },
    travelTips: ["Avoid hot weather travel", "Extra water important", "Exercise well before", "Choose cool flight times"],
    seoTitle: "Siberian Husky Air Travel 2026 | Heat Safety Guide",
    seoDescription: "Flying with a Siberian Husky. Heat sensitivity concerns, seasonal travel advice, crate requirements.",
    seoKeywords: ["Husky flying", "Siberian Husky airline", "Husky travel", "Husky heat"]
  },

  "maine-coon": {
    slug: "maine-coon",
    name: "Maine Coon Cat",
    type: "cat",
    category: "large",
    riskLevel: "LOW",
    physicalTraits: { weight: "10-25 lbs (4.5-11 kg)", lifespan: "12-15 years" },
    travelRisks: {
      respiratory: "Low",
      heatStroke: "Moderate (thick coat)",
      stress: "Low-Moderate",
      altitude: "Low"
    },
    airlineRestrictions: {
      bannedFromCargo: [],
      cabinAllowed: ["Depends on size - many Maine Coons too large"],
      notes: "Large Maine Coons may exceed cabin carrier limits. Check specific airline."
    },
    recommendedCrateSize: { length: "26-32 inches", width: "18-22 inches", height: "18-22 inches" },
    travelTips: ["Check carrier size limits", "May need cargo", "Calm temperament helps", "Familiar bedding"],
    seoTitle: "Maine Coon Cat Air Travel 2026 | Large Cat Flying Guide",
    seoDescription: "Flying with a Maine Coon. Large cat carrier considerations, airline policies, travel tips.",
    seoKeywords: ["Maine Coon flying", "Maine Coon airline", "large cat travel"]
  },

  "siamese": {
    slug: "siamese",
    name: "Siamese Cat",
    type: "cat",
    category: "standard",
    riskLevel: "LOW",
    physicalTraits: { weight: "6-14 lbs (2.7-6 kg)", lifespan: "15-20 years" },
    travelRisks: {
      respiratory: "Low",
      heatStroke: "Low",
      stress: "Moderate (vocal breed)",
      altitude: "Low"
    },
    airlineRestrictions: {
      bannedFromCargo: [],
      cabinAllowed: ["Yes - standard size"],
      notes: "Siamese can travel cabin easily. May vocalize during travel."
    },
    recommendedCrateSize: { length: "22-26 inches", width: "14-18 inches", height: "14-16 inches" },
    travelTips: ["May meow during travel", "Familiar scents help", "Quiet carrier location", "Practice car rides first"],
    seoTitle: "Siamese Cat Air Travel 2026 | Vocal Cat Travel Guide",
    seoDescription: "Flying with a Siamese cat. Managing vocalization, cabin travel tips, stress reduction.",
    seoKeywords: ["Siamese cat flying", "Siamese airline", "Siamese travel"]
  },

  "british-shorthair": {
    slug: "british-shorthair",
    name: "British Shorthair Cat",
    type: "cat",
    category: "brachycephalic-mild",
    riskLevel: "MODERATE",
    physicalTraits: { weight: "9-18 lbs (4-8 kg)", lifespan: "12-20 years" },
    travelRisks: {
      respiratory: "Moderate (mild brachycephaly)",
      heatStroke: "Moderate",
      stress: "Low (calm breed)",
      altitude: "Low-Moderate"
    },
    airlineRestrictions: {
      bannedFromCargo: ["Some airlines classify as brachycephalic"],
      cabinAllowed: ["Yes - check specific airline"],
      notes: "British Shorthairs have mild brachycephaly. Check airline's flat-faced cat policy."
    },
    seoTitle: "British Shorthair Cat Air Travel 2026 | Flat-Face Considerations",
    seoDescription: "Flying with a British Shorthair. Mild brachycephalic cat, airline policies, travel safety.",
    seoKeywords: ["British Shorthair flying", "British Shorthair airline", "flat face cat travel"]
  }
};

// ==================== ADDITIONAL GUIDES ====================
export const additionalGuidesData = {
  "how-to-prepare-pet-for-flight": {
    slug: "how-to-prepare-pet-for-flight",
    title: "How to Prepare Your Pet for Their First Flight: Complete Guide",
    category: "preparation",
    readTime: "12 min",
    lastUpdated: "2026",
    introduction: "Flying is stressful for pets who've never experienced it. From crate training to vet visits, proper preparation can make the difference between a smooth journey and a traumatic experience. Start at least 30 days before your flight.",
    sections: [
      {
        title: "Crate Training: Start 4-6 Weeks Early",
        content: `Your pet should view their crate as a safe haven, not a prison. Rushed crate training leads to anxious pets who panic mid-flight.

• Week 1-2: Place crate in living area with door open. Add treats and meals inside.
• Week 2-3: Start closing door for short periods (5-15 minutes) while home.
• Week 3-4: Increase duration. Practice during your absence.
• Week 4-6: Car rides in crate. Simulate airport conditions.

NEVER force your pet into the crate. Let them explore at their own pace. Positive associations only.`
      },
      {
        title: "Veterinary Preparation",
        content: `Schedule a vet visit 2 weeks before travel (health certificate must be within 10 days of flight).

Discuss with your vet:
• Health certificate requirements
• Rabies vaccination status
• Any anxiety medications (note: most airlines prohibit sedation)
• Travel-specific health concerns for your breed
• Microchip verification

Get all documentation in order. Missing paperwork is a top rejection reason.`
      },
      {
        title: "Physical Conditioning",
        content: `Prepare your pet's body for travel:

• Adjust feeding schedule to match travel day (no food 4-6 hours before)
• Practice water restriction (normal water until 2 hours before)
• Increase exercise the week before (tired pets travel better)
• Groom thoroughly - clean, trimmed nails, comfortable coat length
• For long-haired breeds in summer: consider a trim to prevent overheating`
      },
      {
        title: "Mental Preparation",
        content: `Reduce travel anxiety through exposure:

• Play airport sounds at home (announcements, engine noise)
• Practice car rides of increasing duration
• Expose to carrier movement (carry them around the house)
• Practice being handled by strangers
• Maintain calm energy - pets sense your stress`
      }
    ],
    conclusion: "A well-prepared pet is a calm traveler. The investment in proper preparation pays off in reduced stress for both you and your pet.",
    seoTitle: "How to Prepare Your Pet for Flying 2026 | Complete Preparation Guide",
    seoDescription: "Complete guide to preparing your pet for air travel. Crate training, vet prep, mental conditioning. Start 30+ days before your flight.",
    seoKeywords: ["prepare pet for flight", "pet flight preparation", "crate training for flying", "pet travel prep"]
  },

  "seasonal-pet-travel-guide": {
    slug: "seasonal-pet-travel-guide",
    title: "Seasonal Pet Travel: Best and Worst Times to Fly with Your Pet",
    category: "preparation",
    readTime: "8 min",
    lastUpdated: "2026",
    introduction: "When you fly matters as much as how you fly. Temperature extremes can be deadly for pets in cargo holds, and seasonal embargoes can cancel your pet's reservation. Understanding seasonal risks is essential for safe pet travel.",
    sections: [
      {
        title: "Summer: High Risk Season (June-August)",
        content: `Summer is the MOST DANGEROUS time to fly pets in cargo. Ground temperatures at airports can exceed safe limits.

RISKS:
• Heat stroke in cargo hold and on tarmac
• Temperature embargoes (airlines won't accept pets when >85°F)
• Delayed flights = longer tarmac exposure
• Higher pet mortality rates

IF YOU MUST FLY IN SUMMER:
• Book early morning or late evening flights
• Choose direct flights only (no connections)
• Avoid Phoenix, Las Vegas, Dallas, Miami hubs
• Consider cabin-only travel
• Bring ice packs for carrier`
      },
      {
        title: "Winter: Cold Weather Risks (December-February)",
        content: `Cold can be as dangerous as heat, especially for small or short-haired pets.

RISKS:
• Hypothermia risk when temp <45°F
• Temperature embargoes in cold regions
• Ice storms causing delays and tarmac exposure
• Northern route airports may have restrictions

WINTER TRAVEL TIPS:
• Book midday flights when it's warmest
• Add extra bedding to crate
• Avoid connecting through cold-climate hubs
• Check for winter embargoes on your route`
      },
      {
        title: "Spring & Fall: Optimal Travel Windows",
        content: `March-May and September-November offer the safest conditions for pet travel.

WHY THESE SEASONS ARE BEST:
• Moderate temperatures (fewer embargoes)
• Lower airline travel volume (less chaos)
• Reduced tarmac wait times
• Fewer weather delays

STILL CHECK:
• Specific dates for temperature extremes
• Hurricane season (Atlantic: June-November)
• Regional variations (Arizona spring can be hot)`
      },
      {
        title: "Holiday Periods: Avoid If Possible",
        content: `Peak travel holidays create additional stress and risk:

WORST TIMES:
• Thanksgiving week
• Christmas/New Year (Dec 20 - Jan 3)
• Spring Break
• Memorial Day weekend
• Labor Day weekend

WHY HOLIDAYS ARE RISKY:
• Crowded cargo areas
• Rushed handlers
• Higher chance of delays
• Stressed airline staff
• More connection issues

Book 2-3 weeks before or after holidays if possible.`
      }
    ],
    conclusion: "Choose your travel dates carefully. Spring and fall offer the best conditions, while summer heat and holiday chaos create unnecessary risks. When in doubt, drive.",
    seoTitle: "Best Time to Fly with Pets 2026 | Seasonal Travel Guide",
    seoDescription: "When to fly with your pet. Summer heat dangers, winter cold risks, optimal travel windows. Avoid these high-risk periods.",
    seoKeywords: ["best time fly pet", "summer pet travel danger", "pet travel season", "when to fly with dog"]
  },

  "pet-travel-insurance-guide": {
    slug: "pet-travel-insurance-guide",
    title: "Pet Travel Insurance: Do You Need It? What Does It Cover?",
    category: "preparation",
    readTime: "7 min",
    lastUpdated: "2026",
    introduction: "Airlines limit their liability for pet injuries and deaths. Pet travel insurance fills this gap, but not all policies are created equal. Here's what you need to know before you fly.",
    sections: [
      {
        title: "Airline Liability: What They DON'T Cover",
        content: `Airlines have strict liability limits for pets:

TYPICAL AIRLINE LIABILITY:
• Many exclude liability for brachycephalic breeds entirely
• Pre-existing conditions never covered
• Death from "natural causes" often excluded

THE FINE PRINT:
• You must prove airline negligence
• Acts of nature (weather) excluded
• Ground handling errors may be excluded
• No coverage for emotional distress

Airlines are NOT responsible for pet deaths they deem unavoidable.`
      },
      {
        title: "What Pet Travel Insurance Covers",
        content: `Good pet travel insurance includes:

STANDARD COVERAGE:
• Veterinary expenses from travel injuries
• Emergency medical treatment abroad
• Trip cancellation due to pet illness
• Loss or theft of pet during transit

PREMIUM COVERAGE:
• Death benefits (replacement value)
• Quarantine costs if required
• Return transport if you're hospitalized
• Liability if pet injures someone

WHAT'S USUALLY EXCLUDED:
• Pre-existing conditions
• Brachycephalic breed-specific issues
• Behavioral problems
• Cosmetic procedures`
      },
      {
        title: "Do You Really Need It?",
        content: `Consider insurance IF:

✓ Your pet is flying cargo (higher risk)
✓ Expensive purebred with high replacement value
✓ International travel with quarantine risk
✓ Multiple connections (more handling = more risk)
✓ You couldn't afford emergency vet bills abroad

SKIP IT IF:
• Cabin travel on direct flight
• Short domestic trip
• You have emergency savings
• Existing pet insurance covers travel`
      }
    ],
    conclusion: "Pet travel insurance is worth considering for high-risk travel scenarios. Check if your existing pet health insurance includes travel coverage before buying separate policies.",
    seoTitle: "Pet Travel Insurance Guide 2026 | Coverage & Costs Explained",
    seoDescription: "Do you need pet travel insurance? What airlines cover (and don't), insurance options, when it's worth it.",
    seoKeywords: ["pet travel insurance", "airline pet liability", "pet flight insurance", "traveling pet coverage"]
  },

  "international-pet-travel-documents": {
    slug: "international-pet-travel-documents",
    title: "International Pet Travel Documents: Complete Checklist by Region",
    category: "documentation",
    readTime: "10 min",
    lastUpdated: "2026",
    introduction: "Missing documents = denied boarding or quarantine on arrival. International pet travel requires meticulous paperwork, and requirements vary dramatically by destination. This guide covers documentation for major travel routes.",
    sections: [
      {
        title: "EU Travel: Pet Passport System",
        content: `Traveling within the European Union is simplified by the EU Pet Passport system.

FOR EU RESIDENTS:
• EU Pet Passport (issued by vet)
• Microchip implantation record
• Rabies vaccination (21+ days before)
• Annual renewal required

FOR NON-EU VISITORS:
• Animal Health Certificate (AHC)
• Issued within 10 days of travel
• Must be signed by government vet
• Microchip + rabies required

IMPORTANT: Post-Brexit, UK travelers need AHC for EU entry.`
      },
      {
        title: "USA Entry Requirements",
        content: `US rules depend on origin country and pet type.

DOGS FROM MOST COUNTRIES:
• Rabies vaccination certificate
• Must appear healthy
• CDC may require additional screening from high-risk countries

DOGS FROM HIGH-RISK RABIES COUNTRIES:
• CDC Dog Import Permit
• Rabies serology test (RNATT)
• 28+ day advance notice

CATS:
• No federal requirements
• Some states require health certificates
• Hawaii has quarantine

USDA ENDORSEMENT:
• Required for pets LEAVING the US for most countries
• Get health cert endorsed at USDA office`
      },
      {
        title: "Asia-Pacific Documents",
        content: `AUSTRALIA/NEW ZEALAND:
• Import permit (apply 20+ days early)
• RNATT blood test
• Multiple vet visits with specific timing
• Quarantine booking required
• Start 6+ months before travel

JAPAN:
• Advance notification (40+ days)
• Two rabies vaccinations
• FAVN blood test
• 180-day wait after blood test
• Start 7+ months early

SINGAPORE:
• AVS import license
• Country category determines requirements
• Some countries require blood test
• Apply 2+ weeks before`
      },
      {
        title: "Document Checklist by Timeline",
        content: `6+ MONTHS BEFORE (Strict Countries):
□ Research destination requirements
□ Apply for import permits
□ Schedule first rabies vaccination
□ Blood test if required
□ Start waiting period

2 MONTHS BEFORE:
□ Confirm microchip working
□ Schedule vet for second rabies if needed
□ Verify permit status

2 WEEKS BEFORE:
□ Book vet for health certificate
□ Confirm all vaccinations current

5-10 DAYS BEFORE:
□ Get health certificate signed
□ Get government endorsement if required

DAY OF TRAVEL:
□ Original documents in hand luggage
□ Copies in checked bag
□ Contact info on crate`
      }
    ],
    conclusion: "Documentation errors are the #1 cause of pet travel disasters. Start early, verify everything twice, and keep originals with you at all times.",
    seoTitle: "International Pet Travel Documents 2026 | Complete Checklist",
    seoDescription: "Complete international pet travel documentation guide. EU passport, US requirements, Asia-Pacific rules. Don't miss any paperwork.",
    seoKeywords: ["pet travel documents", "international pet travel", "EU pet passport", "pet import permit"]
  },

  "emergency-pet-travel-situations": {
    slug: "emergency-pet-travel-situations",
    title: "Emergency Pet Travel: What to Do When Things Go Wrong",
    category: "emergency",
    readTime: "9 min",
    lastUpdated: "2026",
    introduction: "Even with perfect preparation, emergencies happen. Lost pets, medical emergencies mid-flight, rejected crates at check-in - knowing how to respond quickly can save your pet's life and your trip.",
    sections: [
      {
        title: "Crate Rejected at Check-In",
        content: `You're at the airport and your crate is rejected. Now what?

IMMEDIATE STEPS:
1. Stay calm - panic doesn't help
2. Ask for SPECIFIC rejection reason
3. Ask if airport has crates for sale (many do)
4. Check if modification is possible (adding bolts, labels)
5. Consider delaying to next flight

IF NO QUICK FIX:
• Some airports have pet stores nearby
• Hardware stores have metal bolts
• Pet relocation services may help last-minute

PREVENTION:
Use our pre-check service. Know BEFORE you get to the airport.`
      },
      {
        title: "Pet Medical Emergency In-Flight",
        content: `Pet becomes ill during flight or immediately after.

IN CABIN:
• Alert flight attendant immediately
• Request emergency veterinary contact at destination
• Keep pet in carrier (don't remove unless directed)
• Monitor breathing and responsiveness

IN CARGO (YOU SUSPECT ISSUE):
• Alert cabin crew of concern
• Request welfare check if possible
• Have destination vet contact ready
• Meet plane at arrival gate if allowed

ON ARRIVAL:
• Go directly to airport veterinary station if available
• Have emergency vet clinic address ready
• Don't wait - seek help immediately`
      },
      {
        title: "Pet Lost During Transit",
        content: `The nightmare scenario: your pet doesn't arrive.

IMMEDIATE ACTIONS:
1. Report to airline cargo immediately
2. Get written acknowledgment
3. Demand tracking information
4. Contact destination cargo facility
5. File missing pet report

GET THESE DETAILS:
• AWB (Air Waybill) number
• Last confirmed location
• Handler names and contacts
• Supervisor contact information

WHILE SEARCHING:
• Alert airport security
• Post on social media (microchip number)
• Contact local animal shelters
• Check if pet escaped at transfer point

PREVENTION: Ensure crate has your contact info, photos inside, and working microchip.`
      },
      {
        title: "Denied Entry at Destination",
        content: `You arrive but your pet is denied entry.

COMMON REASONS:
• Documentation errors
• Expired health certificate
• Missing import permit
• Banned breed not caught before

OPTIONS:
1. Quarantine (if available and you accept)
2. Return transport to origin
3. Transfer to third country that accepts pet
4. Emergency document correction (rarely possible)

HOW TO RESPOND:
• Stay calm and polite with officials
• Ask for exact deficiency
• Request supervisor if needed
• Document everything
• Contact embassy if serious issue

This is why documentation matters.`
      }
    ],
    conclusion: "Hope for the best, prepare for the worst. Have backup plans, emergency contacts, and contingency funds for unexpected situations. Your pet's safety depends on your preparedness.",
    seoTitle: "Pet Travel Emergencies 2026 | What to Do When Things Go Wrong",
    seoDescription: "Emergency pet travel guide. Rejected crate, lost pet, medical emergency, denied entry. Know how to respond.",
    seoKeywords: ["pet travel emergency", "lost pet airport", "pet crate rejected", "pet denied entry"]
  }
};

export default { 
  additionalAirlinesData, 
  additionalCountriesData, 
  additionalBreedsData, 
  additionalGuidesData 
};
